import styled from 'styled-components';

export const ShowMoreButtonWrapper = styled.button`
  font-size: 0.75rem;
  width: 100%;
  font-weight: 400;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #656f7d;
  display: flex;
  padding: 0;
  align-items: center;
  border-radius: 0.25rem;
  height: 1.5rem;
  gap: 0.5rem;

  &:hover {
    background-color: #f6f9fc;
    color: #656f7d;
  }
`;
